import { traducirError, useTraduccion, type ProblemaApi } from '@tallerya/i18n';
import { useAvisos } from '@tallerya/ui';
import { useState } from 'react';

/**
 * Corre las acciones de fila de un listado —activar, desactivar, nombrar
 * principal, reordenar— y dice cómo salió: el éxito como aviso abajo
 * (`useAvisos`), el error en `problema`, que la pantalla muestra arriba del
 * listado con `AvisoError`.
 *
 * Vive aquí y no copiado en cada pantalla porque las copias se desencuentran:
 * la de Sucursales se quedó sin el `catch` después de que las demás lo tenían
 * (#116). Sin red, la petición no responde con un error: lanza. Eso también se
 * dice, o la acción fallaría sin que nada en la pantalla cambie.
 */
export function useAccionDeFila() {
  const { t } = useTraduccion();
  const { avisar } = useAvisos();
  const [problema, setProblema] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  async function hacer(accion: Promise<ProblemaApi | undefined>, exito: string) {
    setProblema(null);
    setOcupado(true);
    let error: ProblemaApi | undefined;
    try {
      error = await accion;
    } catch {
      setProblema(t('ui.formulario.aviso.sinRespuesta'));
      return;
    } finally {
      setOcupado(false);
    }
    if (error) {
      setProblema(error.code ? traducirError(error.code, t) : t('ui.formulario.aviso.sinRespuesta'));
      return;
    }
    avisar({ titulo: exito });
  }

  // `setProblema` sale para la pantalla que dice otros errores en el mismo
  // lugar, como la exportación de Productos y servicios.
  return { hacer, problema, setProblema, ocupado };
}
